import { render, staticRenderFns } from "./WeChatSignInButton.vue?vue&type=template&id=0b097155&"
import script from "./WeChatSignInButton.vue?vue&type=script&lang=js&"
export * from "./WeChatSignInButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports